import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  timelineItemClasses,
  TimelineOppositeContent,
  TimelineSeparator
} from "@mui/lab";
import { Box, CircularProgress, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getMemberAllAssignDataApi } from "src/api/commonapi";
import { notification } from "src/utils/messages";

export default function MemberHistoryModal({
  rowData,
  memberListHistoryModal,
  toggleMemberListHistoryModal
}) {
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    borderRadius: "10px",
    boxShadow: 10,
    p: 4,
    overflowY: "auto"
  };

  const [memberAssignDataHistory, setMemberAssignDataHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleGetAllMemberAssignHistory = async () => {
    setLoading(true);
    const resp = await getMemberAllAssignDataApi({ p_id: rowData.p_id, m_id: rowData.m_id });
    setMemberAssignDataHistory(resp?.data || []);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    setLoading(false);
  };

  useEffect(() => {
    handleGetAllMemberAssignHistory();
  }, []);
  return (
    <Modal
      open={memberListHistoryModal}
      onClose={toggleMemberListHistoryModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6"> ({rowData?.p_name})</Typography>
        </Box>

        {/* Content */}
        {loading ? (
          <Box display="flex" justifyContent="center" mt={3}>
            <CircularProgress />
          </Box>
        ) : memberAssignDataHistory.length === 0 ? (
          <Typography align="center" mt={3}>
            No history found
          </Typography>
        ) : (
          <Timeline
            sx={{
              [`& .${timelineItemClasses.root}:before`]: {
                flex: 0,
                padding: 0
              }
            }}
          >
            {memberAssignDataHistory.map((item, index) => (
              <TimelineItem key={item.m_p_a_id}>
                <TimelineOppositeContent
                  color="text.secondary"
                  style={{
                    textAlign: "left",
                    width: "150px",
                    maxWidth: "150px"
                  }}
                >
                  {item.assign_date}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot color="primary" />
                  {index !== memberAssignDataHistory.length - 1 && <TimelineConnector />}
                </TimelineSeparator>

                <TimelineContent>
                  <Typography variant="body2" color="text.secondary">
                    {item.description}
                  </Typography>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        )}
      </Box>
    </Modal>
  );
}
